import { webLocalStorageAdapter as e } from "./StorageAdapter.mjs";
import { createContext as t, createElement as n, useContext as r } from "react";
//#region src/storage/StorageAdapterContext.ts
var i = t(e), a = ({ adapter: e, children: t }) => n(i.Provider, { value: e }, t), o = () => r(i);
//#endregion
export { a as StorageAdapterProvider, o as useStorageAdapter };
